import * as types from '../actions/actionTypes'

const initState = {
  branchTab: 'все',
}

export default function branchTabsReducer(state = initState, action) {  
  switch (action.type) {
    case types.BRANCH_TABS:
      return { ...state, branchTab: action.branchTab }
    default:
      return state
  }
}
